import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Message } from '../shared/chat-bot/chat-bot.component';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  apiUrl = environment.baseUrl;
  pages: any = [];

  constructor(private http: HttpClient) { }

  login(user) {
    return this.http.post(this.apiUrl + 'token', user);
  }

  signUp(user) {
    return this.http.post(this.apiUrl + 'users/', user);
  }

  getUser() {
    return this.http.get(this.apiUrl + 'users/' + sessionStorage.getItem('loginId'));
  }

  getUserById(userId: any) {
    return this.http.get(this.apiUrl + 'users/getByUsername/' + userId);
  }

  getUsers() {
    return this.http.get(this.apiUrl + 'users');
  }

  userChapters() {
    return this.http.get(this.apiUrl + 'users/getUserStatus/' + sessionStorage.getItem('loginId'));
  }

  userChaptersByUserId(loginId) {
    return this.http.get(this.apiUrl + 'users/getUserStatus/' + loginId);
  }
  userAnswersByUserId(loginId) {
    return this.http.get(this.apiUrl + 'answers/byUser/' + loginId);
  }



  getChapterQuestions(chapterId) {
    return this.http.get(this.apiUrl + 'questions/byChapter/' + chapterId);
  }

  getChapter(chapterId) {
    return this.http.get(this.apiUrl + 'chapters/' + chapterId);
  }

  getChapters() {
    return this.http.get(this.apiUrl + 'chapters/');
  }

  postAnswers(data) {
    return this.http.post(this.apiUrl + 'answers/', data);
  }

  getChatList() {
    return this.http.get(this.apiUrl + `ai/history/?session_id=${sessionStorage.getItem('sessionId')}&user_id=${sessionStorage.getItem('loginId')}`);
  }

  getSummaryImage(chapterId: any) {
    return this.http.get(this.apiUrl + 'ai/chapterCompletion/' + sessionStorage.getItem('loginId') + '/' + chapterId);
  }

  postChatList(history: any) {
    const messageData = {
      session_id: sessionStorage.getItem('sessionId'),
      user_id: sessionStorage.getItem('loginId'),
      history: history,
    };
    console.log('messageData', messageData);
    return this.http.post(this.apiUrl + 'ai/chat', messageData);
  }

  postAudioChat(history: any) {
    // remove all audio from history except the last one
    const textOnlyHistory = history.filter((item: Message) => item.typ !== 'audio');
    const lastAudioMessage = history[history.length - 1];
    if (lastAudioMessage && lastAudioMessage.type === 'audio') {
      textOnlyHistory.push({
        sender: lastAudioMessage.sender,
        message: lastAudioMessage.message,
        typ: 'text',
      });
    }
    const messageData = {
      session_id: sessionStorage.getItem('sessionId'),
      user_id: sessionStorage.getItem('loginId'),
      history: history,
    };

    return new Observable((observer) => {
      fetch(this.apiUrl + 'ai/audio-chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(messageData),
      })
        .then((response) => {
          if (!response.body) {
            observer.error(new Error('Response body is empty'));
            return;
          }
          const reader = response.body.getReader();
          const decoder = new TextDecoder('utf-8');
          let buffer = '';

          const processChunk = ({ done, value }) => {
            if (done) {
              // If there's any data left in the buffer, try to parse it.
              const remaining = buffer.trim();
              if (remaining) {
                try {
                  const finalObj = JSON.parse(remaining);
                  observer.next(finalObj);
                } catch (error) {
                  observer.error(error);
                }
              }
              observer.complete();
              return;
            }

            // Decode the current chunk and append it to the buffer.
            buffer += decoder.decode(value, { stream: true });

            // Split the buffer into lines (each line should be one complete JSON object).
            const lines = buffer.split('\n');

            // The last line may be incomplete. Keep it in the buffer for the next chunk.
            buffer = lines.pop() || '';

            // Process each complete line.
            for (const line of lines) {
              if (line.trim()) {
                try {
                  const jsonObj = JSON.parse(line);
                  observer.next(jsonObj); // Emit the parsed JSON object immediately.
                } catch (error) {
                  observer.error(error);
                  return;
                }
              }
            }

            // Read the next chunk.
            reader.read().then(processChunk);
          };

          // Start processing the stream.
          reader.read().then(processChunk);
        })
        .catch((error) => {
          observer.error(error);
        });
    });


  }

  userChapter(data) {
    return this.http.post(this.apiUrl + 'userchapters/', data);
  }

  userChapterUpdate(data, userChapterId) {
    return this.http.put(this.apiUrl + 'userchapters/' + userChapterId, data);
  }

  getAnswerByUserByChapterId(chapterId: any) {
    return this.http.get(this.apiUrl + 'answers/byUserByChapter/' + sessionStorage.getItem('loginId') + '/' + chapterId);
  }

  getBooks() {
    return this.http.get(this.apiUrl + 'books/');
  }

  getBlogs() {
    return this.http.get(this.apiUrl + 'blogs/');
  }

  getEvents() {
    return this.http.get(this.apiUrl + 'events/');
  }

  getBlogDetails(blogId: any) {
    return this.http.get(this.apiUrl + 'blogs/' + blogId);
  }

  getEventDetails(eventId: any) {
    return this.http.get(this.apiUrl + 'events/' + eventId);
  }

  getPageByKey(key: any) {

    let page = this.pages.filter((item: any) => {
      return item.url == key;
    });

    if (page?.length) {
      return page[0];
    } else {
      return {};
    }

  }

  getPagesList() {
    return this.http.get(this.apiUrl + 'pages/');
  }

  setPages(pages: any) {
    this.pages = pages;
  }

  getForums() {
    return this.http.get(this.apiUrl + 'forums/details/');
  }

  getForumDetails(forumId: any) {
    return this.http.get(this.apiUrl + 'forums/' + forumId);
  }

  getAnswersDetails(forumId: any) {
    return this.http.get(this.apiUrl + 'discussions/byItem/' + forumId);
  }

  saveAnswersDetails(body: any) {
    return this.http.post(this.apiUrl + 'discussions/', body);
  }

  saveQuestionDetails(body: any) {
    return this.http.post(this.apiUrl + 'forums/', body);
  }

  getQrCodes() {
    return this.http.get(this.apiUrl + 'qr/');
  }

  validateQr(qr: any) {
    return this.http.get(this.apiUrl + 'qr/isQrValid/' + qr);
  }

  insertNewQrCodes(list: any) {
    return this.http.post(this.apiUrl + 'qr/all/', {
      "codes": list
    });
  }

  getChapterInfo(id: any) {
    return this.http.get(this.apiUrl + 'chapters/' + id);
  }

  async hashPassword(password) {
    const encoder = new TextEncoder();
    const data = encoder.encode(password);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  }

  encrypt(data: string, key: string) {
    const encryptedData = btoa(data + '##' + key);
    return encryptedData;
  }

  decrypt(encryptedData: string,key: string) {
    const decryptedData = atob(encryptedData).split('##')[0];
    return decryptedData;
  }


  sendEmail(body: any) {
    return this.http.post(this.apiUrl + 'send-notification', body);
  }

  updateUserStatus(id: any, body: any) {
    return this.http.put(this.apiUrl + 'users/updateUserStatus/' + id, body);
  }

  resetPassword(id: any, body: any) {
    return this.http.put(this.apiUrl + 'users/resetPassword/' + id, body);
  }

  getUserStatus(id: any) {
    return this.http.get(this.apiUrl + 'users/getChapterReminders/userId/' + id);
  }

  updateUser(id: any, body: any) {
    return this.http.put(this.apiUrl + 'users/' + id, body);
  }

}
